export default __webpack_public_path__ + "static/media/delete.b1519f3b.svg";